import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgChatCircle = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14 2.625A11.375 11.375 0 0 0 3.957 19.346L2.716 23.07a1.75 1.75 0 0 0 2.214 2.214l3.724-1.241A11.375 11.375 0 1 0 14 2.625Zm0 21a9.61 9.61 0 0 1-4.819-1.292.874.874 0 0 0-.715-.073l-4.091 1.365 1.364-4.09a.875.875 0 0 0-.072-.716A9.625 9.625 0 1 1 14 23.625Z" />
  </svg>
);
export default SvgChatCircle;
